<template>
    <div class="report-filters">
        <div v-click-outside="closeFiltersBlock">

            <template v-if="this.$md.mobile() !== null">
                <div class="search-input-wrapper" v-show="isShowMobileSearch">
                    <input type="text" v-model="table_search_phrase" v-on:keyup.enter="useSearch">
                    <i class="mobile-search" @click="toggleMobileSearch"></i>
                </div>
                <div class="mobile-wrapper" v-show="!isShowMobileSearch">
                    <div class="mobile-filters-wrapper">
                        <i class="mobile-filters" @click="showFiltersBlock"></i>
                    </div>
                    <div class="label">

                    </div>
                    <div class="mobile-search-wrapper">
                        <i class="mobile-search" @click="toggleMobileSearch"></i>
                    </div>
                </div>
            </template>

            <div class="filter-wrap">
                <div class="filter-button-wrap">
                  <span class="filter-button" @click="showFiltersBlock">
                      Filter
                      <i class="arrow-drop-down"></i>
                  </span>
                </div>
                <div class="filter-tags-wrapper" v-show="getFilterData('partnerId').length || getFilterData('tableTypeName').length">

                    <CCFilterTag v-if="getFilterData('partnerId').length"
                                 :options="getAllPartnersList()"
                                 :selectedOptions="getFilterData('partnerId')"
                                 optionId="id"
                                 optionValue="company"
                                 :actionEvent="this.changeFilter.bind(this, 'partnerId')"
                                 :removeEvent="this.changeFilter.bind(this, 'partnerId')"
                                 headerLabel="Partner"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('tableTypeName').length"
                                 :options="getRawTablesTypesList()"
                                 :selectedOptions="getFilterData('tableTypeName')"
                                 optionId="name"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'tableTypeName')"
                                 :removeEvent="this.changeFilter.bind(this, 'tableTypeName')"
                                 headerLabel="Table Types"></CCFilterTag>

                </div>
                <template v-if="!$md.mobile()">
                    <CCCalendar :actionEvent="this.setDateRanges" :namespace="namespace" :dates="dates"></CCCalendar>
                </template>
            </div>
            <div class="filtersList" v-show="isShowFiltersBlock">
                <div v-show="isShowFiltersBlock" class="filters-wrapper">
                    <template v-if="$md.mobile() !== null">
                        <div class="mobile-actions-wrapper" v-bind:style="{'top': scrollOffsetY + 'px'}">
                  <span @click="clearFilters">
                    <i class="close-form"></i>
                  </span>
                            <span>Choose Filters</span>
                            <span @click="applyFilters">Save</span>
                        </div>
                    </template>
                    <div class="filtersBlock">

                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getAllPartnersList()"
                                            :selectedOptions="getFilterData('partnerId')"
                                            optionId="id"
                                            optionValue="company"
                                            :actionEvent="this.updateFilter.bind(this, 'partnerId')"
                                            :removeEvent="this.changeFilter.bind(this, 'partnerId')"
                                            headerLabel="Partner"></CCFilterSelect>
                        </div>

                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getRawTablesTypesList()"
                                            :selectedOptions="getFilterData('tableTypeName')"
                                            optionId="name"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'tableTypeName')"
                                            :removeEvent="this.changeFilter.bind(this, 'tableTypeName')"
                                            headerLabel="Table Types"></CCFilterSelect>
                        </div>

                    </div>

                    <template v-if="this.$md.mobile() === null">
                        <div class="filters-bottom-wrapper">
                            <div>
                                <button @click="clearFilters()">Cancel</button>
                                <button class="apply-button" @click="applyFilters()">Apply</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import CCFilterSelect from '@/components/common/CCFilterSelect';
    import CCFilterTag from '@/components/common/CCFilterTag';
    import CCFilterTagInput from '@/components/common/CCFilterTagInput';
    import CCCalendar from '@/components/common/CCCalendar';
    import CCSwitchToggle from '@/components/common/CCSwitchToggle';
    import CCSelect from '@/components/common/CCSelect';
    import BaseReportFiltersMixin from '@/components/mixins/baseReportFiltersMixin';
    import RawTablesPartnerReportMixin from '@/components/mixins/rawPartnersDataReportMixin';

    export default {
        name: "cc-raw-data-partners-report-filters",
        components: {
            CCFilterSelect,
            CCFilterTag,
            CCFilterTagInput,
            CCCalendar,
            CCSwitchToggle,
            CCSelect
        },
        mixins: [
            BaseReportFiltersMixin,
            RawTablesPartnerReportMixin
        ],
        props: {
            namespace: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                advancedFilters: {},
                dates: {
                    startDate: null,
                    endDate: null,
                    startDateB: null,
                    endDateB: null
                }
            }
        },
        computed: {
            scrollOffsetY: function () {
                return this.$store.getters.getScrollOffsetY;
            },
        },
        methods: {
            checkFilters: function () {
                return true;
            },
        },
        created: function () {


        }
    }
</script>

<style lang="scss" scoped>

    .filters-wrapper {
        border: 1px solid $border-color;
        border-radius: $border-radius;
        box-shadow: 1px 3px 7px 1px #cbcccd;
    }

    .advanced-filters-toggle {
        padding-bottom: 15px;
        border-bottom: 1px solid $border-color;

        &.open {
            border-bottom: 0;
        }

        & > span {
            cursor: pointer;
        }

        .advanced-filter-icon-toggle {
            display: inline-block;
            width: 0.65em;
            height: 0.65em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-toggle-bottom.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            &.open {
                background-image: url('/static/img/icon-toggle-top.svg');
            }
        }
    }

    .advanced-filters-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        & > div.block-wrapper {
            padding: 25px;
            text-align: left;
            border: 1px solid $border-color;
            border-radius: $border-radius;
            border-right: 0;

            & > div {
                text-align: left;
                margin-top: 25px;
                margin-bottom: 25px;

                & > div {
                    margin-top: 10px;

                    & > input {
                        max-width: 75px;
                        padding: 7px 5px 7px 0;
                        border: 1px solid $border-color;
                        border-radius: 3px;
                        text-indent: 5px;
                        text-align: center;

                        &.input-text-long {
                            max-width: 100%;
                            width: 100%;
                            text-align: left;
                        }
                    }
                }
            }

            & > div:first-child {
                margin-top: 0;
            }

            & > div:last-child {
                margin-bottom: 0;
            }

            & > .select-wrapper {
                text-align: center;

                & > div {
                    margin-top: 15px;

                    & > select {
                        min-width: 50%;
                    }
                }
            }

        }

        & > div:first-child {
            border-left: 0;
        }
    }

    .filters-bottom-wrapper {
        text-align: right;
        margin-right: 25px;
        padding: 10px 0 10px 0;

        & > div > button {
            background-color: #fff;
            color: #676767;
            padding: 10px 25px;
            border: 1px solid $border-color;
            border-radius: 3px;

            &.apply-button {
                color: #fff;
                background-color: #4a90e2;
                border: 1px solid #3376c5;
                cursor: pointer;
            }

        }

        & > div > button:first-child {
            margin-right: 15px;
        }
    }

    .report-filters {
        margin-bottom: 10px;
        width: 100%;
    }

    .filter-wrap {
        display: grid;
        grid-template-columns: 90px 5fr auto;
    }

    .filter-tags-wrapper {
        text-align: left;
    }

    .filter-button-wrap {
        text-align: left;

        .filter-button {
            display: inline-block;
            padding: 5px 8px;
            color: #797979;
            font-size: 14px;
            background-color: #fff;
            border: 1px solid $border-color;
            border-radius: 3px;
            cursor: pointer;

            & > .arrow-drop-down {
                display: inline-block;
                width: 0.65em;
                height: 0.65em;
                margin-right: 5px;
                margin-left: 5px;
                background-image: url('/static/img/icon-filter-dropdown.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
        }
    }

    .filtersList {
        position: absolute;
        z-index: 999;
        background-color: #fff;
    }

    .filtersBlock {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        padding: 15px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    @include desktop-and-below {
        .filtersBlock {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @include tablet-landscape-and-below {
        .filtersBlock {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @include mobile-only {

        .filtersList {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: block;
            margin-right: 0;
            z-index: 10;
            width: 100vw;
        }

        .mobile-actions-wrapper {
            padding-top: 15px;
            background-color: #4a90e2;
            padding-bottom: 15px;
            font-size: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: end;
            position: sticky;
            z-index: 999;

            & > span {
                color: #fff;
            }

            & > span > i.close-form {
                display: inline-block;
                width: 1.15em;
                height: 1.15em;
                background-image: url('/static/img/icon-close.svg');
                background-repeat: no-repeat;
                background-position: left center;
                background-size: contain;
            }

            & > span:first-child {
                margin-left: 15px;
            }

            & > span:last-child {
                margin-right: 15px;
            }
        }

        .filters-wrapper {
            border: 0;
        }

        .advanced-filters-wrapper {
            grid-template-columns: auto;

            & > div.block-wrapper {
                padding: 5px;
                margin-right: 5px;
                margin-left: 5px;
                border: 0;

                & > div {
                    display: flex;
                    flex-wrap: nowrap;
                    flex-direction: row;
                    align-items: baseline;
                    justify-content: space-between;

                    & > div {
                        margin-top: 0;
                    }
                }
            }
        }

        .advanced-filters-toggle {
            border-bottom: 0;
        }

        .filtersBlock {
            grid-template-columns: 1fr;
            padding-top: 15px;
            padding-left: 4px;
            padding-right: 5px;
            grid-gap: 10px;
        }

        .filter-button-wrap {
            display: none;
        }

        .filter-tags-wrapper {
            display: none;
        }

        .report-filters {
            margin-top: 15px;
            margin-bottom: 15px;
        }

        .mobile-wrapper {
            display: grid;
            grid-template-columns: 45px auto 45px;

            & > .label {
                margin: auto 0;
                max-width: 70vw;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                & > span {
                    font-size: 16px;
                }
            }
        }

        .mobile-filters {
            display: inline-block;
            width: 1.25em;
            height: 1.25em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-mobile-filters.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .mobile-search {
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/filters-search-icon.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .search-input-wrapper {
            display: grid;
            grid-template-columns: 1fr auto;
            margin-left: 15px;
            margin-right: 15px;

            & > input {
                margin-right: 20px;
                border: 1px solid $border-color;
                border-radius: 5px;
                text-indent: 1em;
                padding: 3px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/reports/rawDataPartnersReport/CCRawDataPartnersReportFilters.vue